export default "__VITE_ASSET__b4dcbcd9__"